// Demos pendientes de seguimiento del closer: agendadas, ya pasadas y suyas.
export function computePendingDemos(demos, { userId, nowMs }) {
  return (demos || [])
    .filter(
      (d) =>
        d.status === "agendada" &&
        d.closer === userId &&
        d.scheduled_at &&
        new Date(d.scheduled_at).getTime() < nowMs,
    )
    .sort((a, b) => new Date(a.scheduled_at) - new Date(b.scheduled_at));
}
